export default "__VITE_ASSET__CqysOw_F__"